'use strict';

const angular = require('angular');

import { ISeason, IPickupOption, IPickupUserEvent, IPickupEvent, IPickupUtilsService, IPickupOptionsService } from '../../interfaces';

export class AdminPickupPrintComponent {
  protected $http: ng.IHttpService;
  PickupUtils: IPickupUtilsService;
  PickupOptionsService: IPickupOptionsService;

  season: ISeason;
  pickup: IPickupEvent;
  userEvents: IPickupUserEvent[];
  pickupOptionName: any = null;
  extraInformation: {};

  /*ngInjector*/
  constructor($http, PickupUtils, PickupOptionsService) {
    this.$http = $http;
    this.PickupUtils = PickupUtils;
    this.PickupOptionsService = PickupOptionsService;
  }

  public $onInit() {
    let resolve = (this as any).resolve;
    if (_.has(resolve, 'pickup') && resolve.pickup !== null) {
      this.pickup = resolve.pickup;
      this.season = resolve.season;
      this.load();
      this.loadPickupOptionName();
    } else {
      this.cancel();
    }
  }

  private load() {
    let scope = this;
    this.$http.get('/api/pickupUserEvents/byEvent/'+this.pickup._id)
    .then(result => {
      scope.userEvents = result.data as IPickupUserEvent[];
      scope.userEvents = _.filter(scope.userEvents, userEvent => {
        return userEvent.basket !== null && userEvent.basket.enable;
      });
      _.each(scope.userEvents, userEvent => {
        scope.getExtras(userEvent)
        scope.calculateStartTime(userEvent);
      });
      scope.userEvents = _.sortBy(scope.userEvents, userEvent => {
        return userEvent.basket.membership.lastName + userEvent.basket.membership.firstName;
      });

      scope.extraInformation = scope.getExtraInformation();
    });
  }

  loadPickupOptionName() {
    let scope = this;
    this.$http.get('/api/pickupOptions/' + this.pickup.pickupOption )
      .then(res => {
        let pickupOptionRes = res.data as IPickupOption;
        scope.pickupOptionName = pickupOptionRes.name;
      });
  }

  protected calculateStartTime(userEvent) {
    if (userEvent.pickupEventOverride) {
      userEvent.pickupEventOverride.startDate = this.PickupUtils.getStartDateFor(this.season, userEvent.pickupEventOverride.pickupOption, userEvent.pickupEventOverride);
    }
    if (userEvent.pickupEvent) {
      userEvent.pickupEvent.startDate = this.PickupUtils.getStartDateFor(this.season, userEvent.pickupEvent.pickupOption, userEvent.pickupEvent);
    }
  }

  public getExtraInformation() {
    let extraInfo = {};
    let scope = this;

    
    _.each(scope.pickup.availableExtras, extra => {
      let fullExtra = _.find(scope.season.availableExtras, candidate => {
        return (candidate._id == extra);
      });
      if (fullExtra) {
        extraInfo[fullExtra._id] = {
          'count': 0,
          'name': fullExtra.extraBases[0].name,
          'unit': fullExtra.extraBases[0].unit
        };
      }
    });
    
    _.each(scope.userEvents, userEvent => {
      
      if (((userEvent.pickupEventOverride && userEvent.pickupEventOverride._id === scope.pickup._id) ||
      (!userEvent.pickupEventOverride && userEvent.pickupEvent._id === scope.pickup._id))&&
      !userEvent.absent) {
        _.each(userEvent.basket.extras, extra => {
          if (_.has(extraInfo, extra.extra)) {
            extraInfo[extra.extra.toString()]['count'] += extra.quantity; 
          }
        });
      }
    });
    return extraInfo;
  }

  getExtras(userEvent) {
    let pickupExtras = _.filter(this.season.availableExtras, candidate => {
      return _.find(this.pickup.availableExtras, (child) => {
        return candidate._id == child;
      }) != null;
    });
    let result = [];
    _.each(pickupExtras, candidate => {
      _.each(userEvent.basket.extras, (child) => {
        if (candidate._id == child.extra) {
          result.push(
            {
              'quantity': child.quantity,
              'unit': candidate.extraBases[0].unit,
              'name': candidate.extraBases[0].name
            });
        }
      }) != null;
    });
    userEvent.$extras = result;
  }

  public ok() {
    (this as any).close({$value: 'ok'});
  };

  public cancel() {
    (this as any).dismiss({$value: 'cancel'});
  };

  public getRequiredBaskets() {
    let requiredBaskets = 0;
    let scope = this;
    _.each(this.userEvents, userEvent => {
      if (((userEvent.pickupEventOverride && userEvent.pickupEventOverride._id === scope.pickup._id) ||
      (!userEvent.pickupEventOverride && userEvent.pickupEvent._id === scope.pickup._id))&&
      !userEvent.absent) {
        requiredBaskets++;
      }
    });
    return requiredBaskets;
  }

  /*window*/
  print() {
    window.print();
  }

}


export default angular.module('terrappApp.adminPickups')
  .component('adminPickupPrint', {
    template: require('./adminPickupPrint.html'),
    controller: AdminPickupPrintComponent,
    controllerAs: '$ctrl',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
  }).name;



// WEBPACK FOOTER //
// ./client/app/admin/adminPickups/adminPickupPrint.component.ts